import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {getInvestorAccount} from '@/repositories/beneva-api/endpoints/client-info';
import {DetailedInvestorAccount} from '@/types/client-info';

type UseGetDetailedInvestorAccountMutationParams = {investorNo: string; accountNo: string};

export const useGetDetailedInvestorAccountMutation = (
  options: Partial<
    Omit<
      UseMutationOptions<DetailedInvestorAccount, unknown, UseGetDetailedInvestorAccountMutationParams, unknown>,
      'mutationKey' | 'mutationFn'
    >
  > = {},
) =>
  useMutation({
    mutationKey: ['getInvestorAccount'],
    mutationFn: async ({investorNo, accountNo}: UseGetDetailedInvestorAccountMutationParams) => {
      const {data: account} = await getInvestorAccount(investorNo, accountNo, true);
      return account;
    },
    retry: false,
    ...options,
  });
